const wearWhenSlider = new Swiper('.wear-when-slider', {
  slidesPerView: 1,
  loop: true,
  spaceBetween: 10,
  allowTouchMove: true,
  speed: 500,
  loopedSlides: 2,
  centeredSlides: true,
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  autoplay: {
    delay: 5000,
  },
  breakpoints: {
    768: {
      allowTouchMove: false,
      centeredSlides: false,
    }
  }
});

// Sync buttons to slider
const wearWhenButtons = document.querySelectorAll('.wear-when-button');
wearWhenButtons.forEach(button => {
  button.addEventListener('click', event => {
    const idx = button.dataset.index;
    wearWhenSlider.slideToLoop(idx);

    document.querySelectorAll('.wear-when-button.active').forEach(button => {
      button.classList.remove('active');
    });

    document.querySelectorAll(`.wear-when-button[data-index="${idx}"]`).forEach(button => {
      button.classList.add('active');
    });
  });
});

// Sync slider to buttons
wearWhenSlider.on('slideChange', slider => {
  let idx = slider.realIndex;

  document.querySelectorAll('.wear-when-button.active').forEach(button => {
    button.classList.remove('active');
  });

  document.querySelectorAll(`.wear-when-button[data-index="${idx}"]`).forEach(button => {
    button.classList.add('active');
  });
});